import { render, staticRenderFns } from "./gameStageBackview.vue?vue&type=template&id=addb049e&scoped=true"
import script from "./gameStageBackview.vue?vue&type=script&lang=js"
export * from "./gameStageBackview.vue?vue&type=script&lang=js"
import style0 from "./gameStageBackview.vue?vue&type=style&index=0&id=addb049e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "addb049e",
  null
  
)

export default component.exports